module.exports = __webpack_public_path__ + "resources/img/equipment_tab_img4_m.db3cabb593400ed3dc91c4319e30d063.jpg";